import _defineProperty from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/repo/fe/aisledx/node_modules/@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { WebCryptoAlgorithmSuite, WebCryptoEncryptionMaterial, WebCryptoDecryptionMaterial, SignatureKey, needs, readOnlyProperty, VerificationKey, immutableBaseClass, KeyringWebCrypto, CommitmentPolicySuites } from '@aws-crypto/material-management';
import { ENCODED_SIGNER_KEY } from '@aws-crypto/serialize';
import { getWebCryptoBackend, getNonZeroByteBackend } from '@aws-crypto/web-crypto-backend';
import { fromBase64, toBase64 } from '@aws-sdk/util-base64-browser';
/**
 * The WebCryptoDefaultCryptographicMaterialsManager is a specific implementation of the CryptographicMaterialsManager.
 * New cryptography materials managers SHOULD extend from WebCryptoMaterialsManager.
 * Users should never need to create an instance of a WebCryptoDefaultCryptographicMaterialsManager.
 */

export var WebCryptoDefaultCryptographicMaterialsManager = /*#__PURE__*/function () {
  function WebCryptoDefaultCryptographicMaterialsManager(keyring) {
    _classCallCheck(this, WebCryptoDefaultCryptographicMaterialsManager);

    /* Precondition: keyrings must be a KeyringWebCrypto. */
    needs(keyring instanceof KeyringWebCrypto, 'Unsupported type.');
    readOnlyProperty(this, 'keyring', keyring);
  }

  _createClass(WebCryptoDefaultCryptographicMaterialsManager, [{
    key: "getEncryptionMaterials",
    value: function () {
      var _getEncryptionMaterials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var suite, encryptionContext, commitmentPolicy, material;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                suite = _ref.suite, encryptionContext = _ref.encryptionContext, commitmentPolicy = _ref.commitmentPolicy;
                suite = suite || new WebCryptoAlgorithmSuite(CommitmentPolicySuites[commitmentPolicy].defaultAlgorithmSuite);
                /* Precondition: WebCryptoDefaultCryptographicMaterialsManager must reserve the ENCODED_SIGNER_KEY constant from @aws-crypto/serialize.
                 * A CryptographicMaterialsManager can change entries to the encryptionContext
                 * but changing these values has consequences.
                 * The DefaultCryptographicMaterialsManager uses the value in the encryption context to store public signing key.
                 * If the caller is using this value in their encryption context the Default CMM is probably not the CMM they want to use.
                 */

                needs(!Object.prototype.hasOwnProperty.call(encryptionContext, ENCODED_SIGNER_KEY), "Reserved encryptionContext value ".concat(ENCODED_SIGNER_KEY, " not allowed."));
                _context.t0 = this.keyring;
                _context.next = 6;
                return this._initializeEncryptionMaterial(suite, encryptionContext);

              case 6:
                _context.t1 = _context.sent;
                _context.next = 9;
                return _context.t0.onEncrypt.call(_context.t0, _context.t1);

              case 9:
                material = _context.sent;

                /* Postcondition: The WebCryptoEncryptionMaterial must contain a valid dataKey.
                 * This verifies that the data key matches the algorithm suite specification
                 * and that the unencrypted data key is non-NULL.
                 * See: cryptographic_materials.ts, `getUnencryptedDataKey`
                 */
                needs(material.hasValidKey(), 'Unencrypted data key is invalid.');
                /* Postcondition: The WebCryptoEncryptionMaterial must contain at least 1 EncryptedDataKey. */

                needs(material.encryptedDataKeys.length, 'No EncryptedDataKeys: the ciphertext can never be decrypted.');
                return _context.abrupt("return", material);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getEncryptionMaterials(_x) {
        return _getEncryptionMaterials.apply(this, arguments);
      }

      return getEncryptionMaterials;
    }()
  }, {
    key: "decryptMaterials",
    value: function () {
      var _decryptMaterials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
        var suite, encryptedDataKeys, encryptionContext, material;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                suite = _ref2.suite, encryptedDataKeys = _ref2.encryptedDataKeys, encryptionContext = _ref2.encryptionContext;
                _context2.t0 = this.keyring;
                _context2.next = 4;
                return this._initializeDecryptionMaterial(suite, encryptionContext);

              case 4:
                _context2.t1 = _context2.sent;
                _context2.t2 = encryptedDataKeys.slice();
                _context2.next = 8;
                return _context2.t0.onDecrypt.call(_context2.t0, _context2.t1, _context2.t2);

              case 8:
                material = _context2.sent;

                /* Postcondition: The WebCryptoDecryptionMaterial must contain a valid dataKey.
                 * See: cryptographic_materials.ts, `getUnencryptedDataKey` also verifies
                 * that the unencrypted data key has not been manipulated,
                 * that the data key matches the algorithm suite specification
                 * and that the unencrypted data key is non-NULL.
                 */
                needs(material.hasValidKey(), 'Unencrypted data key is invalid.');
                return _context2.abrupt("return", material);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function decryptMaterials(_x2) {
        return _decryptMaterials.apply(this, arguments);
      }

      return decryptMaterials;
    }()
  }, {
    key: "_initializeEncryptionMaterial",
    value: function () {
      var _initializeEncryptionMaterial2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(suite, encryptionContext) {
        var namedCurve, backend, subtle, webCryptoAlgorithm, extractable, usages, format, _yield$subtle$generat, publicKey, privateKey, publicKeyBytes, compressPoint, signatureKey;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                namedCurve = suite.signatureCurve;
                /* Check for early return (Postcondition): The WebCryptoAlgorithmSuite specification must support a signatureCurve to generate a signing key. */

                if (namedCurve) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return", new WebCryptoEncryptionMaterial(suite, encryptionContext));

              case 3:
                _context3.next = 5;
                return getWebCryptoBackend();

              case 5:
                backend = _context3.sent;
                subtle = getNonZeroByteBackend(backend);
                webCryptoAlgorithm = {
                  name: 'ECDSA',
                  namedCurve: namedCurve
                };
                extractable = false;
                usages = ['sign'];
                format = 'raw';
                _context3.next = 13;
                return subtle.generateKey(webCryptoAlgorithm, extractable, usages);

              case 13:
                _yield$subtle$generat = _context3.sent;
                publicKey = _yield$subtle$generat.publicKey;
                privateKey = _yield$subtle$generat.privateKey;
                _context3.next = 18;
                return subtle.exportKey(format, publicKey);

              case 18:
                publicKeyBytes = _context3.sent;
                compressPoint = SignatureKey.encodeCompressPoint(new Uint8Array(publicKeyBytes), suite);
                signatureKey = new SignatureKey(privateKey, compressPoint, suite);
                return _context3.abrupt("return", new WebCryptoEncryptionMaterial(suite, _objectSpread(_objectSpread({}, encryptionContext), {}, _defineProperty({}, ENCODED_SIGNER_KEY, toBase64(compressPoint)))).setSignatureKey(signatureKey));

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function _initializeEncryptionMaterial(_x3, _x4) {
        return _initializeEncryptionMaterial2.apply(this, arguments);
      }

      return _initializeEncryptionMaterial;
    }()
  }, {
    key: "_initializeDecryptionMaterial",
    value: function () {
      var _initializeDecryptionMaterial2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(suite, encryptionContext) {
        var namedCurve, compressPoint, backend, subtle, webCryptoAlgorithm, extractable, usages, format, publicKeyBytes, publicKey;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                namedCurve = suite.signatureCurve;
                /* Check for early return (Postcondition): The WebCryptoAlgorithmSuite specification must support a signatureCurve to extract a verification key. */

                if (namedCurve) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return", new WebCryptoDecryptionMaterial(suite, encryptionContext));

              case 3:
                if (encryptionContext) {
                  _context4.next = 5;
                  break;
                }

                throw new Error('Encryption context does not contain required public key.');

              case 5:
                compressPoint = encryptionContext[ENCODED_SIGNER_KEY];
                /* Precondition: WebCryptoDefaultCryptographicMaterialsManager The context must contain the public key. */

                needs(compressPoint, 'Context does not contain required public key.');
                _context4.next = 9;
                return getWebCryptoBackend();

              case 9:
                backend = _context4.sent;
                subtle = getNonZeroByteBackend(backend);
                webCryptoAlgorithm = {
                  name: 'ECDSA',
                  namedCurve: namedCurve
                };
                extractable = false;
                usages = ['verify'];
                format = 'raw';
                publicKeyBytes = VerificationKey.decodeCompressPoint(fromBase64(compressPoint), suite);
                _context4.next = 18;
                return subtle.importKey(format, publicKeyBytes, webCryptoAlgorithm, extractable, usages);

              case 18:
                publicKey = _context4.sent;
                return _context4.abrupt("return", new WebCryptoDecryptionMaterial(suite, encryptionContext).setVerificationKey(new VerificationKey(publicKey, suite)));

              case 20:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function _initializeDecryptionMaterial(_x5, _x6) {
        return _initializeDecryptionMaterial2.apply(this, arguments);
      }

      return _initializeDecryptionMaterial;
    }()
  }]);

  return WebCryptoDefaultCryptographicMaterialsManager;
}();
immutableBaseClass(WebCryptoDefaultCryptographicMaterialsManager);